<template>
  <v-layout pt-2 pb-2>
    <v-flex>
      <v-form action.prevent="">
      <v-card>
        <v-card-title>
          <span class="title font-weight-light">{{ title }}</span>
          <gss-tooltip>
            <slot name="tooltip">
              <v-layout column>
                <v-layout
                  justify-center
                  v-for="(hint, i) in splittedHintImages"
                  :key="`hint${i}`"
                >
                  <v-flex
                    xs6
                    v-for="img in hint"
                    :key="`hint-image${img.url}`"
                  >
                    <v-card class="align-center">
                      <v-card-title primary-title>
                        <div class="headline">{{ img.title }}</div>
                      </v-card-title>
                      <img class="dialog-img" :src="img.url">
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-layout>
            </slot>

          </gss-tooltip>
        </v-card-title>
        <v-card-text>
          <slot />
        </v-card-text>
        <!-- TODO: SUBMIT HERE -->
      </v-card>
    </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
  import GssTooltip from './../styleSettingsFormComponents/GssTooltip'
  import { splitEvery } from 'ramda'
export default {
  name: 'SettingsFormWrapper',
  components: {
    GssTooltip
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    hintImages: {
      type: Array,
      default: () => ([])
    }
  },
  computed: {
    splittedHintImages () {
      return splitEvery(2, this.hintImages)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/FormWrapper.vue